import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { CancelIcon } from '@depop/web-ui-kit/Icons/CancelIcon';
import { useTranslations } from 'next-intl';

import { type CustomOverrides } from '../index';

import styles from './styles.module.css';

type Props = {
  title?: string;
  showCloseButton?: boolean;
  customOverrides?: CustomOverrides;
  onClose?: () => void;
};

function PopoverHeader({
  title,
  showCloseButton = true,
  customOverrides,
  onClose,
}: Props) {
  const t = useTranslations('common');

  if (!showCloseButton && !title && !customOverrides?.headerTitle) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {customOverrides?.headerTitle ||
        (title && <Heading variant="lg">{title}</Heading>)}
      {showCloseButton && (
        <button className={styles.closeButton} onClick={onClose}>
          <CancelIcon title={t('Close')} aria-label={t('Close')} />
        </button>
      )}
    </div>
  );
}

export { PopoverHeader };
